import { Box, Stack, Typography } from "@mui/material";

const TOTAL_STEPS = 4;

export default function SalesImportStepIndicator({ currentStep = 1 }) {
  const safeStep = Math.min(Math.max(Number(currentStep) || 1, 1), TOTAL_STEPS);

  return (
    <Stack
      role="progressbar"
      aria-label="Progreso de la importación"
      aria-valuemin={1}
      aria-valuemax={TOTAL_STEPS}
      aria-valuenow={safeStep}
      direction="row"
      spacing={1.25}
      sx={{ alignItems: "center", justifyContent: "center" }}
    >
      <Typography
        component="span"
        sx={{
          position: "absolute",
          width: 1,
          height: 1,
          p: 0,
          m: -1,
          overflow: "hidden",
          clip: "rect(0, 0, 0, 0)",
          whiteSpace: "nowrap",
          border: 0,
        }}
      >
        Paso {safeStep} de {TOTAL_STEPS}
      </Typography>

      {Array.from({ length: TOTAL_STEPS }, (_, index) => {
        const step = index + 1;
        const active = step === safeStep;
        const completed = step < safeStep;
        return (
          <Box
            key={step}
            aria-hidden="true"
            sx={{
              width: 20,
              height: 20,
              borderRadius: "50%",
              border: "2px solid",
              borderColor: active || completed ? "primary.500" : "neutral.600",
              bgcolor: completed
                ? "primary.500"
                : active
                ? "secondary.50"
                : "neutral.300",
              boxShadow: active
                ? "0px 0px 0px 2px rgba(23, 31, 76, 0.08)"
                : "none",
            }}
          />
        );
      })}
    </Stack>
  );
}
